import { GLTFLoader, DRACOLoader } from 'three/examples/jsm/Addons.js'
import { useLoader } from '@react-three/fiber'

// Hook condiviso per caricare GLB (con decoder Draco locale in
// public/draco/). Usato dai modelli di scena (ModelsHandler), dalle
// scatole/GLB prodotto (ProductBox) e ovunque serva un glTF.
export const loadModel = (path) =>
  useLoader(GLTFLoader, path, (loader) => {
    const dracoLoader = new DRACOLoader()
    dracoLoader.setDecoderPath('draco/')
    loader.setDRACOLoader(dracoLoader)
  })
